import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import getRouter from 'router';
// import Vconsole from 'vconsole'
import 'antd-mobile/dist/antd-mobile.css';
import 'style/antd.less';


// const Vco = new Vconsole();
(function (designWidth, maxWidth) {
    let doc = document;
    let win = window;
    let docEl = doc.documentElement;
    let remStyle = document.createElement('style');
    let tid;

    function refreshRem() {
        let width = docEl.getBoundingClientRect().width;// 获取当前设备的宽度
        maxWidth = maxWidth || 750;
        width > maxWidth && (width = maxWidth);
        let rem = width * 100 / designWidth;// 设置1个单位的rem为多少px
        remStyle.innerHTML = 'html{font-size:' + rem + 'px;}';
    }

    if (docEl.firstElementChild) {
        docEl.firstElementChild.appendChild(remStyle);
    } else {
        let wrap = doc.createElement("div");
        wrap.appendChild(remStyle);
        doc.write(wrap.innerHTML);
        wrap = null;
    }
    // 要等 viewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次;
    refreshRem();

    win.addEventListener("resize", function () {
        clearTimeout(tid); //防止执行两次
        tid = setTimeout(refreshRem, 300);
    }, false);

    win.addEventListener("pageshow", function (e) {
        if (e.persisted) { // 浏览器后退的时候重新计算
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    if (doc.readyState === "complete") {
        doc.body.style.fontSize = "16px";
    } else {
        doc.addEventListener("DOMContentLoaded", function (e) {
            doc.body.style.fontSize = "16px";
        }, false);
    }
})(750, 1280);

ReactDOM.render(
    <Router>
        {getRouter()}
    </Router>, document.getElementById('root'));

